<template>
	<div>
		<el-card>
			<el-tabs v-model="activetab" @tab-click="GetTabData">
				 <el-tab-pane label="批量报价" name="批量报价">
					 <rateimport ref="rateimport"></rateimport>
				 </el-tab-pane>
				 <el-tab-pane label="单个报价" name="单个报价">
					 <ratesingly ref="ratesingly"></ratesingly>
				 </el-tab-pane>
			</el-tabs>
		</el-card>
	</div>
</template>

<script>
import rateimport from '@/components/order/orderrate_import.vue';
import ratesingly from '@/components/order/orderrate_singly.vue';
import Utils from '../../lib/util.js';	
export default {
	components: {
		rateimport,
		ratesingly
	},
	data(){
		return {
			activetab:'批量报价',
			activeTabIndex:0,
			tabs:[{name:'批量报价'},{name:'单个报价'}]
		};
	},
	mounted() {
		this.GetTabData({index:0});
	},
	methods: {
		GetTabData(tab){
			if (tab != undefined) {
				this.activeTabIndex = tab.index;
				this.activetab = this.tabs[this.activeTabIndex].name;
				if(this.activetab=='批量报价')
					this.$refs.rateimport.init();
				else
					this.$refs.ratesingly.init();
			}
		}
	}
}	
</script>

<style>
</style>
